<template>
  <div class="our-beliefs-conversation-content" id="plataforma-de-marca-nossas-crencas-conversa-diaria" data-search-anchor>
    <div class="our-beliefs-conversation-overlay-title-image">
      <h1 class="our-beliefs-conversation-image-conversation-title" style="margin-top: 4rem;">
        {{ ourBeliefsConversationImageTitle }}
      </h1>
      <h1 class="our-beliefs-conversation-image-conversation-title" style="margin-bottom: 2rem;">
        {{ ourBeliefsConversationImageTitle2 }}
      </h1>
      <p class="our-beliefs-conversation-image-conversation-text">
        {{ ourBeliefsConversationImageTitle3 }}
      </p>
    </div>

    <div
      class="our-beliefs-conversation-banner-image"
      :style="{ backgroundImage: `url(${ourBeliefsConversationImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import OurBeliefsPageMixin from '@/mixins/our-beliefs-page-mixin'
import { OurBeliefsPageStore } from '@/store/brand-plataform-page/our-beliefs-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurBeliefsConversationSection extends Mixins(OurBeliefsPageMixin) {
  ourBeliefsPageStore: PageStoreContract = getModule(OurBeliefsPageStore, this.$store)

  get ourBeliefsConversationImageTitle(): string {
    return this.getElementText(3, 0)
  }

  get ourBeliefsConversationImageSrc(): string {
    return this.getElementMedia(3, 0)
  }

  get ourBeliefsConversationImageTitle2(): string {
    return this.getElementText(3, 1)
  }

  get ourBeliefsConversationImageTitle3(): string {
    return this.getElementText(3, 2)
  }

  async getOurBeliefsPageStore(): Promise<void> {
    await this.ourBeliefsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.ourBeliefsPageStore.isLoading) {
      await this.getOurBeliefsPageStore()
    }
  }
}
</script>

<style lang="scss">
.our-beliefs-conversation-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;   
}

.our-beliefs-conversation-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.our-beliefs-conversation-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.our-beliefs-conversation-image-conversation-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.our-beliefs-conversation-image-conversation-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
